import { FormControlLabel, Checkbox as MuiCheckbox } from "@mui/material";

import { styled } from "@mui/material/styles";

const CheckboxWithStyles = styled(MuiCheckbox)`
  &.Mui-checked {
    color: #c4c4c4;
  }
`;

const Checkbox = (props) => {
  return (
    <>
      <FormControlLabel
        control={<CheckboxWithStyles name={props?.label} {...props} />}
        label={props?.label || ""}
      />
    </>
  );
};

export default Checkbox;
